import { createSSRApp, ref } from 'vue'

import App from './pages/Wrapper.vue'

import { createRouter } from './router.js'
import { createPinia } from 'pinia'
import { useAuthStore } from '@store/pinia/auth.store.js'
import { getMe } from '@api'
import { systemApi } from '@/axios-instance.js'
import { getTokenFromHeaders, readTokenFromCookie } from '@/utils/authToken.js'

export async function createApp(options = {}) {
  const ssrState = options?.ssrState || {}
  const headers = options?.headers || null
  const app = createSSRApp(App)
  app.use(createPinia())
  app.provide('ssrState', ssrState)
  app.config.globalProperties.$ssrState = ssrState
  const auth = useAuthStore() // <-- ГЛОБАЛЬНОЕ реактивное состояние
  const isClient = typeof window !== 'undefined'
  if (isClient) {
    systemApi.interceptors.response.use(undefined, error => {
      const requestToken = error?.config?.headers?.Authorization
      if (error?.response?.status === 401 && auth.token && requestToken === `Bearer ${auth.token}`) {
        auth.logout()
      }
      return Promise.reject(error)
    })
  }
  const token = isClient
    ? localStorage.getItem('token') || readTokenFromCookie(document.cookie)
    : getTokenFromHeaders(headers)

  auth.setAuth({ token })

  if (token) {
    try {
      const data = await getMe(token)
      auth.setAuth({
        user: data.user.email,
        role: data.user.role,
        token: data.token || token
      })
    } catch (e) {
      if (e?.response?.status === 401) auth.logout()
    }
  }
  const router = createRouter()
  app.use(router)

  return { app, router, ssrState }
}
